<template>
    <div>
        <div class="source-complaint ml lf">
          <div class="content-wrap">
            <div class="inner-content-wrap">
              <div id="myChart" style="width:96%;height:3rem;margin: 0 auto;"></div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import title from '../title'
export default {
  name: 'sourceComplaint',
  data(){
    return {
      titlemsg:"供应商数据"
    }
  },
  mounted(){
    this.drawLine();
  },
  updated(){

  },
  methods:{
    drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'));
        var option;

        option = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            top: '5%',
            left: 'center',
            textStyle:{
                color:'#fff'
            }
          },
          series: [
            {
              name: 'Access From',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2,
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '40',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: [
                { value: 1048, name: '已入驻数量' },
                { value: 735, name: '已申请数量' },
                { value: 280, name: '待审核数量' },
              ]
            }
          ]
        };

        option && myChart.setOption(option);
    }
  },
  components: {
    'title-h3': title
  }
}

</script>
<style scoped>
  .source-complaint{width: 32.7%;height:4.06rem;}
  .content-wrap{width: 100%; height: 3.53rem; margin-top: 0.03rem;  border-radius: 4px; padding-top: .1rem}
  .content-wrap .inner-content-wrap{width: 97%; margin: 0 auto; height: 3.43rem;}
  #myChart{width: 96%; margin: 0 auto;height:3rem; padding-top:.215rem; overflow: hidden}
</style>



// WEBPACK FOOTER //
// src/components/supplier/sourceComplaint.vue